import { Component, OnInit, Input, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModalComponent } from 'core/components/modal/modal.component';
import { JobsService } from 'core/services/jobs.service';
import { DynamicFormComponent, QuestionBase, DropdownQuestion } from 'core/components';

@Component({
  selector: 'lms-change-access-courses',
  templateUrl: './change-access-courses.component.html',
  styleUrls: ['./change-access-courses.component.scss']
})
export class ChangesAccessComponent implements OnInit {
  @Input() catalogueId: string;
  @Output() confirm = new EventEmitter<any>();
  @ViewChild(DynamicFormComponent, { static: false })
  public dynamicForm: DynamicFormComponent;
  @ViewChild('ModalChangeAccess', { static: false })
  public ModalChangeAccess: ModalComponent;
  public selectedCourses: any;
  public accessQuestions: QuestionBase<any>[] = [];
  public defaultAccessMode: any;
  constructor(
    public activatedRoute: ActivatedRoute,
    public translate: TranslateService,
    public elementRef: ElementRef,
    public jobsService: JobsService
  ) {}

  ngOnInit() {}

  changeAccess({ accessMode }) {
    const jobData = {
      jobType: this.jobsService.jobTypes.UPDATE_COURSE_VISIBILITY_BULK,
      courses: [...this.selectedCourses.keys()].map((id) => ({ id })),
      accessMode,
      catalogueId: this.catalogueId
    };
    this.confirm.emit(jobData);
    this.cancelModal();
  }

  openModal(selectedCourses, defaultAccessMode) {
    this.defaultAccessMode = defaultAccessMode;
    this.selectedCourses = selectedCourses;
    this.newDropdownOptions();
    this.ModalChangeAccess.open();
  }
  cancelModal() {
    this.ModalChangeAccess.close();
  }

  newDropdownOptions() {
    this.accessQuestions = [
      new DropdownQuestion({
        key: 'accessMode',
        label: 'courses.accessInputLabel',
        options: [
          {
            key: 'default',
            value: this.translate.instant('courses.config.accessModes.default', {
              mode: this.translate.instant(`courses.config.accessModes.${this.defaultAccessMode}`)
            })
          },
          { key: 'open', value: this.translate.instant('courses.config.accessModes.open') },
          { key: 'limited', value: this.translate.instant('courses.config.accessModes.limited') },
          { key: 'unavailable', value: this.translate.instant('courses.config.accessModes.unavailable') }
        ],
        value: ''
      })
    ];
  }

  public ngOnDestroy(): void {}
}
